var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#F7F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#EEF0F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 29,
    rx: 0.5,
    fill: "white",
    stroke: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5395 8H13.4637V9.46499C15.2039 9.47483 16.9458 9.4471 18.6845 9.47304C18.7698 9.46239 18.8563 9.47136 18.9376 9.49925C19.0189 9.52714 19.0927 9.57322 19.1535 9.63399C19.2143 9.69475 19.2603 9.76858 19.2882 9.84986C19.3161 9.93114 19.3251 10.0177 19.3144 10.103C19.3422 13.1439 19.3079 16.1865 19.3308 19.2292C19.3144 19.5572 19.3633 19.9227 19.1746 20.213C18.9213 20.3468 18.6343 20.4034 18.3491 20.3758C16.7213 20.3678 15.0933 20.371 13.4637 20.371V21.9988H12.4501C9.96908 21.5474 7.48331 21.1339 4.99992 20.6975C4.99873 16.8998 4.99873 13.1024 4.99992 9.30549C7.51252 8.87112 10.0242 8.42811 12.5395 8Z",
    fill: "#D24625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4624 9.95361H18.8347V19.8839H13.4624V18.5817H17.3694V17.9303H13.4624V17.1164H17.3694V16.4653H13.4639C13.4621 16.1463 13.4621 15.827 13.4609 15.508C13.7806 15.6233 14.122 15.6659 14.4602 15.6326C14.7984 15.5994 15.125 15.4911 15.416 15.3157C15.7129 15.1208 15.9588 14.8578 16.1332 14.5485C16.3077 14.2393 16.4056 13.8928 16.4189 13.538C15.7034 13.5329 14.9897 13.5347 14.2766 13.5347C14.2751 12.8264 14.2847 12.1183 14.262 11.412C13.9937 11.4642 13.7281 11.5194 13.4627 11.5763V9.95361H13.4624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6037 11.0719C15.1588 11.1067 15.6823 11.3423 16.0765 11.7346C16.4707 12.127 16.7087 12.6494 16.746 13.2044C16.0305 13.2127 15.3168 13.2095 14.6019 13.2095C14.6019 12.4963 14.6004 11.7835 14.6037 11.0719Z",
    fill: "#D24625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61307 12.3011C8.49701 12.3435 9.56818 11.9511 10.3007 12.6136C11.0025 13.465 10.8167 15.0311 9.77657 15.5406C9.39737 15.6908 8.98617 15.7421 8.58168 15.6896C8.57989 16.3256 8.5793 16.9621 8.57989 17.5991C8.25712 17.5711 7.93425 17.544 7.61128 17.5177C7.59384 15.7789 7.59444 14.0399 7.61307 12.3011V12.3011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5782 13.1817C8.89898 13.1671 9.29609 13.1084 9.51282 13.4095C9.60001 13.5733 9.64737 13.7554 9.65105 13.9409C9.65472 14.1264 9.61462 14.3102 9.53399 14.4774C9.34856 14.8128 8.9285 14.7803 8.60443 14.8193C8.56985 14.2741 8.57343 13.7285 8.5782 13.1817Z",
    fill: "#D24625"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_12066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3297,
    height: 14,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.5871cfac939e5714dd5d38d11998c4c1.svg";
export { ForwardRef as ReactComponent };